import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// react-router keeps the scroll position across navigations; without this,
// opening a page from a link at the bottom of a long page lands mid-page.
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
}
